/* ============================================================
   CART DISABLED — runtime kill-switch.
   Intercepts every cart-related action (form submit, AJAX add,
   click handlers, drawer open) so nothing reaches Shopify's cart.
   To re-enable: remove the <script> for this file from
   layout/theme.liquid. No other code needs to change.
   ============================================================ */
(function () {
  'use strict';

  function disable(e) {
    if (e && e.preventDefault) e.preventDefault();
    if (e && e.stopPropagation) e.stopPropagation();
    if (e && e.stopImmediatePropagation) e.stopImmediatePropagation();
    return false;
  }

  // Replace the global CartDrawer so any call to addItem / open is a no-op
  function neutraliseCartDrawer() {
    var noop = function () { return Promise.resolve({ items: [] }); };
    var stub = { addItem: noop, open: function () {}, close: function () {}, refresh: noop };
    try { Object.defineProperty(window, 'CartDrawer', { value: stub, writable: false, configurable: true }); }
    catch (_) { window.CartDrawer = stub; }
  }

  // Intercept fetch() requests to /cart endpoints
  function patchFetch() {
    if (typeof window.fetch !== 'function' || window.__cartFetchPatched) return;
    var origFetch = window.fetch.bind(window);
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      if (/\/cart\/(add|update|change|clear)/i.test(url)) {
        return Promise.resolve(new Response(JSON.stringify({ status: 'disabled', message: 'Cart is disabled.' }), {
          status: 200,
          headers: { 'Content-Type': 'application/json' }
        }));
      }
      return origFetch(input, init);
    };
    window.__cartFetchPatched = true;
  }

  // Intercept XHR requests too (legacy code paths)
  function patchXHR() {
    if (window.__cartXhrPatched) return;
    var OrigOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.__cartBlocked = /\/cart\/(add|update|change|clear)/i.test(url || '');
      return OrigOpen.apply(this, arguments);
    };
    var OrigSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = function (body) {
      if (this.__cartBlocked) {
        var self = this;
        setTimeout(function () {
          Object.defineProperty(self, 'readyState', { configurable: true, get: function () { return 4; } });
          Object.defineProperty(self, 'status',     { configurable: true, get: function () { return 200; } });
          Object.defineProperty(self, 'response',   { configurable: true, get: function () { return '{}'; } });
          Object.defineProperty(self, 'responseText', { configurable: true, get: function () { return '{}'; } });
          if (typeof self.onreadystatechange === 'function') self.onreadystatechange();
          if (typeof self.onload === 'function') self.onload();
        }, 0);
        return;
      }
      return OrigSend.apply(this, arguments);
    };
    window.__cartXhrPatched = true;
  }

  // Block any add-to-cart form submission
  function bindFormBlock() {
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.action) return;
      var action = String(form.action);
      if (/\/cart\/add/.test(action) || form.matches('[data-pdp-form], #pdp-form, #rcMpForm, [action*="/cart/add"]')) {
        return disable(e);
      }
    }, true);
  }

  // Block clicks on any add-to-cart trigger
  function bindClickBlock() {
    var selector = [
      '[data-atc-btn]',
      '.pdp-atc-btn',
      '.btn-atc',
      '#addToCart',
      '#rcBuyNow',
      '.btn-buy',
      '.sticky-atc',
      '#stickyAtc',
      '.add-btn',
      '.cc-add',
      '[onclick*="CartDrawer"]',
      '.shopify-payment-button button',
      '.shopify-payment-button__button'
    ].join(',');
    document.addEventListener('click', function (e) {
      var t = e.target && e.target.closest ? e.target.closest(selector) : null;
      if (t) return disable(e);
    }, true);
  }

  function init() {
    neutraliseCartDrawer();
    patchFetch();
    patchXHR();
    bindFormBlock();
    bindClickBlock();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
